import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function PeopleTie({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      color={color}
      fontSize={size}
      style={style}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 11.0005C14.4853 11.0005 16.5 8.98581 16.5 6.50049C16.5 4.01516 14.4853 2.00049 12 2.00049C9.51467 2.00049 7.5 4.01516 7.5 6.50049C7.5 8.98581 9.51467 11.0005 12 11.0005ZM12 3.01859C13.923 3.01859 15.4819 4.57744 15.4819 6.50049C15.4819 8.42353 13.923 9.98239 12 9.98239C10.077 9.98239 8.5181 8.42353 8.5181 6.50049C8.5181 4.57744 10.077 3.01859 12 3.01859ZM9.71807 13.3288C6.14265 14.3242 3.51926 17.6016 3.51926 21.4914C3.51926 21.7726 3.29109 22.0005 3.00963 22.0005C2.72817 22.0005 2.5 21.7726 2.5 21.4914C2.5 16.2496 6.75306 12.0005 11.9995 12.0005C17.2461 12.0005 21.5 16.2497 21.5 21.4914C21.5 21.7726 21.2718 22.0005 20.9904 22.0005C20.7089 22.0005 20.4807 21.7726 20.4807 21.4914C20.4807 17.602 17.8571 14.3247 14.2818 13.329L12.6498 15.4714L14.5911 18.4557C14.72 18.6538 14.6926 18.915 14.5255 19.082L12.3495 21.257C12.1542 21.4522 11.8378 21.4522 11.6425 21.257L9.46654 19.082C9.29943 18.915 9.27205 18.6538 9.40089 18.4557L11.3455 15.4664L9.71807 13.3288ZM13.1928 13.1019L11.9996 14.6683L10.807 13.1018C11.1966 13.047 11.5947 13.0187 11.9995 13.0187C12.4045 13.0187 12.8029 13.0471 13.1928 13.1019ZM11.996 20.1964L13.5319 18.6613L11.996 16.3003L10.4601 18.6613L11.996 20.1964Z'
      />
    </svg>
  );
}
